export default "__VITE_ASSET__wcVDESEC__"